































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Liability extends Vue {
  @Prop() readonly doc!: any;
}
